import { render } from "./SubTray.vue?vue&type=template&id=45bb6cae&scoped=true"
import script from "./SubTray.vue?vue&type=script&lang=js"
export * from "./SubTray.vue?vue&type=script&lang=js"

import "./SubTray.vue?vue&type=style&index=0&id=45bb6cae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bb6cae"]])

export default __exports__